import React from "react";

import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { ReactComponent as Delete } from "../../../../Assets/Images/DeleteOutlined.svg";
import { ReactComponent as Edit } from "../../../../Assets/Images/EditOutlined.svg";
import { getProviderDisplayName } from "../../../../Utils/WordFormatter/ProviderAlias";
import { Text1 } from "../../../atoms/Typography/Text/Text";

const formatFeeValue = (row) => {
  const feeType = row.type?.trim()?.toLowerCase();

  if (feeType === "percentage") {
    return row.percentage != null ? `${row.percentage}%` : "-";
  }

  if (feeType === "fixed") {
    return row.amount != null
      ? `LKR ${Number(row.amount).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "-";
  }

  return "-";
};

export const ConvenienceFeeTable = ({ rows, onEdit, onDelete, t }) => {
  if (!rows || rows.length === 0) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 3,
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
          textAlign: "center",
        }}
      >
        <Text1 text={t("glossary:convinience-fee.no-content")} />
      </Paper>
    );
  }

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        border: "1px solid #E0E0E0",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <Table>
        <TableHead
          sx={{
            backgroundColor: "#F5F5F5",
          }}
        >
          <TableRow>
            <TableCell sx={{ fontWeight: 400 }}>
              {t("glossary:convinience-fee.provider")}
            </TableCell>
            <TableCell sx={{ fontWeight: 400 }}>
              {t("glossary:convinience-fee.type")}
            </TableCell>
            <TableCell sx={{ fontWeight: 400 }}>
              {t("glossary:convinience-fee.value")}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 400 }}>
              {t("common:table-field.actions")}
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} hover>
              <TableCell>
                {getProviderDisplayName(row.providerName) || "-"}
              </TableCell>
              <TableCell>{row.type?.trim() || "-"}</TableCell>
              <TableCell>{formatFeeValue(row)}</TableCell>
              <TableCell align="right">
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => onEdit(row)}
                  >
                    <Edit
                      role="img"
                      type="img"
                      aria-label="Edit Icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </IconButton>

                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => onDelete(row)}
                    aria-label="Delete convenience fee"
                  >
                    <Delete
                      role="img"
                      type="img"
                      aria-label="Delete Icon"
                      width={"20px"}
                    />
                  </IconButton>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
